import './styles.scss';

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import useHover from '@assets/scripts/hooks/useHover';

import { PageContext } from '@assets/scripts/context/page-context';
import Form from '@components/molecules/Form';

import forms from '@data/forms';

const FormMessage = ({
	modifiers,
	className,
	title,
	text,
	contact,
	children,
	...otherProps
}) => {
	const baseClass = 'form-message';
	const defaultClass = 'box box--no-border';

	const rootClass = cx(baseClass, className, defaultClass, {
		[`${baseClass}--${modifiers}`]: modifiers,
	});

	const { currentLanguage } = useContext(PageContext);

	const sendContactForm = (inputs, handleServerResponse) => {
		fetch('https://formspree.io/myynokkp', {
			method: 'POST',
			headers: new Headers({
				'Content-Type': 'application/json',
			}),
			mode: 'cors',
			body: JSON.stringify(inputs),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.error) handleServerResponse(false, data.error);
				else
					handleServerResponse(
						true,
						forms[currentLanguage].contactForm.success
					);
			})
			.catch((error) => {
				handleServerResponse(false, error.toString());
			});
	};

	// interaction
	const [hoverOn, hoverOff] = useHover();

	return (
		<div className={rootClass} {...otherProps} data-animation-page>
			<h2>{title}</h2>
			{(text || contact) && (
				<p>
					{text}
					{': '}
					<a
						href="mailto:hello@superhuit.ch"
						data-target
						onMouseEnter={() => hoverOn()}
						onMouseLeave={() => hoverOff()}
					>
						{contact}
					</a>
				</p>
			)}

			<Form
				fields={[
					{
						type: 'textarea',
						id: 'message',
						name: 'message',
						label: forms[currentLanguage].contactForm.message.label,
						validation: 'required',
					},
					{
						type: 'text',
						id: 'first-name',
						name: 'first-name',
						label: forms[currentLanguage].contactForm.firstName.label,
						placeholder:
							forms[currentLanguage].contactForm.firstName.placeholder,
						className: 'form-message__input',
						validation: 'required',
					},
					{
						type: 'text',
						id: 'last-name',
						name: 'last-name',
						label: forms[currentLanguage].contactForm.lastName.label,
						placeholder:
							forms[currentLanguage].contactForm.lastName.placeholder,
						className: 'form-message__input',
						validation: 'required',
					},
					{
						type: 'email',
						id: 'email',
						name: 'email',
						label: forms[currentLanguage].contactForm.email.label,
						placeholder:
							forms[currentLanguage].contactForm.email
								.placeholder,
						className: 'form-message__input',
						validation: 'email',
					},
					{
						type: 'tel',
						id: 'phone',
						name: 'phone',
						label: forms[currentLanguage].contactForm.phone.label,
						placeholder:
							forms[currentLanguage].contactForm.phone.placeholder,
						className: 'form-message__input',
					},
					{
						type: 'checkbox',
						id: 'gdpr',
						label: forms[currentLanguage].contactForm.gdpr,
						className: 'form-message__input',
						validation: 'required',
					},
				]}
				onFormSubmit={sendContactForm}
				submit={forms[currentLanguage].contactForm.send}
			/>
		</div>
	);
};

FormMessage.propTypes = {
	modifiers: PropTypes.string,
	className: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	text: PropTypes.string,
	contact: PropTypes.string,
};

export default FormMessage;
